<template>
    <button
        v-tippy="t('editorToggleBulletList')"
        :class="[
            buttonState(editor.can().toggleBulletList(), editor.isActive('bulletList')),
            'flex-none rounded p-1 text-sm',
        ]"
        :disabled="!editor.can().toggleBulletList()"
        @click="editor.chain().focus().toggleBulletList().run()"
    >
        <MdiFormatListBulleted class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatListBulleted from 'materialdesignicons-vue3/icons/MdiFormatListBulleted.js';

    defineExpose({
        name: 'UnorderedListButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;
</script>
